const { sanitiseBatchNo } = require('../../../batch/tools')
const { SHIPSY_SOURCE, STOCK_TRANSACTION_TYPES } = require('../../constants')

// GRN payload:
//   { request_id, grn_date, items: [
//       { po_reference, sku_code, batch_number, grn_quantity, created_by, ... }
//     ] }
async function extract (payload, { mainApi }) {
  const items = payload && payload.items
  if (!Array.isArray(items) || items.length === 0) return []

  const shipmentNumber = items[0].po_reference
  if (!shipmentNumber) return []

  let shipment
  try {
    shipment = await mainApi.shipment.getShipmentByNumber({ shipmentNumber })
  } catch (err) {
    return []
  }
  if (!shipment) return []

  const requestId = String(payload.request_id)
  const rows = []

  for (const item of items) {
    const quantity = Number(item.grn_quantity)
    if (quantity <= 0) continue

    rows.push({
      source: SHIPSY_SOURCE,
      type: STOCK_TRANSACTION_TYPES.GRN,
      request_id: requestId,
      origin: shipment.origin.id,
      origin_zone: null,
      destination: shipment.destination.id,
      destination_zone: null,
      sku: String(item.sku_code),
      batch: sanitiseBatchNo(item.batch_number || 'UNKNOWN'),
      quantity,
      reason: null,
      payload: item,
      created_at: payload.grn_date,
      created_by: item.created_by,
      updated_at: payload.grn_date,
      updated_by: item.created_by
    })
  }

  return rows
}

module.exports = extract
